import { E_ScoreAlarmStatus, E_ScoreStatus } from "@/api/moudules/score.types"

/**
 * $t('enum.E_ScoreLevelRange__Detail.A')
 * $t('enum.E_ScoreLevelRange__Detail.B')
 * $t('enum.E_ScoreLevelRange__Detail.C')
 */
export enum E_ScoreLevelRange {
    A = 'A',
    B = 'B',
    C = 'C'
}

export const ScoreLevelRangeOptions = Object.freeze([
    E_ScoreLevelRange.A,
    E_ScoreLevelRange.B,
    E_ScoreLevelRange.C,
])

export const ScoreLevelRangeInfo = {
    [E_ScoreLevelRange.A]: {
        min: 80,
        max: 100,
    },
    [E_ScoreLevelRange.B]: {
        min: 60,
        max: 79,
    },
    [E_ScoreLevelRange.C]: {
        min: 0,
        max: 59,
    }
}

export function showRangeValue(r: E_ScoreLevelRange) {
    const {
        min,
        max
    } = ScoreLevelRangeInfo[r]
    return `${min}-${max}`
}

export const ScoreAlarmStatusOptions = Object.freeze([
    E_ScoreAlarmStatus.Yes,
    E_ScoreAlarmStatus.No,
])

export const ScoreStatusOptions = Object.freeze([
    E_ScoreStatus.Normal,
    E_ScoreStatus.NeedData,
])
